import React from 'react'

const CellWrapper = ({ children }) => {
    return <div className="tableCell">{children}</div>
}

export default CellWrapper